import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { hasCookieChoice, setTrackingConsent } from "@/lib/analytics";

/**
 * PECR/GDPR cookie consent banner. Essential cookies (auth, preferences) are
 * always used; analytics/advertising pixels (Reddit, Meta) only load after the
 * user clicks Accept. Shown once until a choice is stored.
 */
export function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show only if no choice has been made yet.
    if (!hasCookieChoice()) setVisible(true);
  }, []);

  if (!visible) return null;

  const choose = (granted: boolean) => {
    setTrackingConsent(granted);
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-[60] p-3 sm:p-4"
    >
      <div className="mx-auto max-w-3xl border border-border/60 bg-background/95 backdrop-blur px-4 py-3 shadow-2xl flex flex-col sm:flex-row sm:items-center gap-3">
        <p className="text-xs leading-relaxed text-muted-foreground flex-1">
          We use essential cookies to run the app. With your consent we also use
          analytics &amp; advertising cookies (Reddit, Meta) to measure marketing.
          See our{" "}
          <Link to="/privacy" className="text-primary hover:underline">Privacy Policy</Link>.
        </p>
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={() => choose(false)}
            className="px-3 py-1.5 text-xs border border-border/50 text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors"
          >
            Reject non-essential
          </button>
          <button
            onClick={() => choose(true)}
            className="px-4 py-1.5 text-xs font-medium bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
          >
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}
